import { render, staticRenderFns } from "./PbnToken.vue?vue&type=template&id=f63d6adc&scoped=true&"
import script from "./PbnToken.vue?vue&type=script&lang=js&"
export * from "./PbnToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63d6adc",
  null
  
)

export default component.exports